// ── Filter state used by the filter modal and page ─────────────────

export interface SettlementOrAdvanceApiFilterValues {
  commodityId: string;
  serialSettlementNbrs: string;
  serialAdvanceNbrs: string;
  customerIds: string[];
}

export const DEFAULT_SETTLEMENT_OR_ADVANCE_FILTER_VALUES: SettlementOrAdvanceApiFilterValues = {
  commodityId: "",
  serialSettlementNbrs: "",
  serialAdvanceNbrs: "",
  customerIds: [],
};

export const DEFAULT_PAGE_SIZE = 100;
